import { observer } from "mobx-react-lite";
import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";
import { useTran } from "@/hooks";
import { readOrgCount } from "@/features/esg/utils/org-scope.utils";
import { getUnitTypeMeta } from "@/features/organization/utils/organization.helpers";

const OrgFlatChecklist = observer(
  ({ organizations, selectedOrgIds, countById, toggleSelectedOrgId }) => {
    const { t } = useTran();
    const selectedIdSet = new Set(selectedOrgIds);

    if (!organizations?.length) {
      return (
        <div className="rounded-radius border border-border bg-card p-4 text-center text-sm text-muted-foreground">
          {t("No organizations available.")}
        </div>
      );
    }

    return (
      <div className="rounded-radius border border-border bg-card shadow-sm">
        <div className="flex items-start justify-between gap-2 border-b border-border px-4 py-3">
          <div>
            <p className="text-base font-semibold text-foreground">
              {t("Organizations")}
            </p>
            <p className="text-xs text-muted-foreground">
              {t("Select organizations to filter SME survey submissions.")}
            </p>
          </div>
        </div>

        <div className="max-h-[70vh] space-y-1 overflow-y-auto p-3">
          {organizations.map((org) => {
            const isChecked = selectedIdSet.has(org.id);
            const count = readOrgCount(countById, org.id);
            const meta = getUnitTypeMeta(
              org?.unitLevel ||
                org?.unit_level ||
                org?.unitType ||
                org?.unit_type ||
                "level_1",
            );
            const Icon = meta.icon;

            return (
              <label
                key={org.id}
                className="flex cursor-pointer items-center gap-2 rounded-radius px-3 py-2 transition hover:bg-muted/60"
              >
                <Checkbox
                  checked={isChecked}
                  onCheckedChange={(checked) =>
                    toggleSelectedOrgId(org.id, Boolean(checked))
                  }
                />
                <span
                  className={`flex h-8 w-8 items-center justify-center rounded-full bg-background shadow-sm ${meta.color}`}
                >
                  <Icon className="h-4 w-4" />
                </span>
                <span className="flex-1 text-sm text-foreground">
                  {org.displayName || org.name}
                </span>
                <Badge
                  variant="outline"
                  className="border-border bg-background text-[11px] text-muted-foreground"
                >
                  {count}
                </Badge>
              </label>
            );
          })}
        </div>
      </div>
    );
  },
);

export default OrgFlatChecklist;
